// Joining a tasting from "tasting now": a participant simply opens the session; a member of the
// group it is open to first becomes a participant (the edge checks that), then opens it.
import { call } from "../edgeApi";
import { navigate } from "../router";
import { TastingSessionView } from "./tastingSession";

export type JoinRight = "participant" | "group";

export async function joinTasting(sessionId: string, right: JoinRight): Promise<void> {
  const id = encodeURIComponent(sessionId);
  if (right === "group") {
    await call(TastingSessionView, `/v1/sessions/${id}/join`, { method: "POST", body: "{}" });
  }
  navigate(`/session/${id}`);
}
